import React, { useState } from "react";
import { FaLinkedinIn, FaPhone, FaRegCopy } from "react-icons/fa6";
import { SiGmail } from "react-icons/si";
import { IoLocationSharp } from "react-icons/io5";

const TooltipItem = ({ item, idx }) => {
  const [copied, setCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipHovered, setTooltipHovered] = useState(false);

  const closeToolTip = () => {
    setTimeout(() => {
      setCopied(false);
      setTooltipHovered(false);
    }, 2500);
  };

  const handleCopy = async () => {
    if (!item.copy) return;

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(item.copy);
      } else {
        fallbackCopyText(item.copy);
      }
      setCopied(true);
      closeToolTip();
    } catch (err) {
      console.error("Copy failed:", err);
      fallbackCopyText(item.copy);
      setCopied(true);
      closeToolTip();
    }
  };

  const fallbackCopyText = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.opacity = "0";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
      console.error("Fallback copy failed:", err);
    }

    document.body.removeChild(textArea);
  };

  const shouldShowTooltip = isHovered || tooltipHovered || copied;

  return (
    <div key={idx} className="relative text-blue text-2xl">
      <div
        className="hover p-2 -m-2 rounded-full hover:bg-gray-100 transition-colors"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {item.link ? (
          <a href={item.link} target="_blank" rel="noreferrer">
            {item.icon}
          </a>
        ) : (
          item.icon
        )}
      </div>

      {shouldShowTooltip && (
        <div
          className="absolute bottom-full mb-1 left-1/2 transform -translate-x-1/2 z-10 transition-opacity duration-300 opacity-100"
          onMouseEnter={() => setTooltipHovered(true)}
          onMouseLeave={() => setTooltipHovered(false)}
        >
          <div className="relative bg-white text-blue text-base px-4 py-3 rounded-lg shadow-lg w-max min-w-[120px] text-center">
            {copied ? (
              // Centered "Copied!" text
              <span className="block w-full text-sm font-rubik text-center">
                Copied!
              </span>
            ) : (
              // Normal layout with icon and button
              <div className="flex items-center gap-2">
                <span className="text-sm font-rubik">{item.tooltip}</span>
                {item.copy && (
                  <button onClick={handleCopy} className="flex-shrink-0">
                    <FaRegCopy className="text-gray-500 hover:text-black transition-colors" />
                  </button>
                )}
              </div>
            )}

            {/* Tooltip arrow */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-3 h-3 rotate-45 bg-white shadow -mt-1.5" />
          </div>
        </div>
      )}
    </div>
  );
};

export const Footer = () => {
  const items = [
    {
      icon: <IoLocationSharp />,
      tooltip: "Dearborn, MI, USA",
    },
    {
      icon: <SiGmail />,
      tooltip: "vishalms@umich.edu",
      copy: "vishalms@umich.edu",
    },
    {
      icon: <FaPhone />,
      tooltip: "+1 (313)-675-1143",
      copy: "+1 (313)-675-1143",
    },
    {
      icon: <FaLinkedinIn />,
      link: "https://www.linkedin.com/in/vishal-m-s-71373a147",
      tooltip: "LinkedIn Profile",
    },
  ];

  return (
    <div className="flex gap-6 p-4 justify-center">
      {items.map((item, idx) => (
        <TooltipItem key={idx} item={item} idx={idx} />
      ))}
    </div>
  );
};

export default Footer;
